
import { ResetStylesProcessor } from './processors/ResetStylesProcessor';
import { ContainerStylesProcessor } from './processors/ContainerStylesProcessor';
import { LogoStylesProcessor } from './processors/LogoStylesProcessor';
import { LayoutStylesProcessor } from './processors/LayoutStylesProcessor';
import { ButtonStylesProcessor } from './processors/ButtonStylesProcessor';
import { SpacingStylesProcessor } from './processors/SpacingStylesProcessor';
import { CardStylesProcessor } from './processors/CardStylesProcessor';
import { StepIndicatorStylesProcessor } from './processors/StepIndicatorStylesProcessor';

/**
 * BaseStyles provides the essential CSS for the calculator component
 */
export class BaseStyles {
  /**
   * Add essential base styles directly to ensure proper rendering
   */
  static getBaseStylesContent(): string {
    return `
      ${ContainerStylesProcessor.createContainerStyles()}
      ${LogoStylesProcessor.createLogoStyles()}
      ${LayoutStylesProcessor.createLayoutStyles()}
      ${ButtonStylesProcessor.createButtonStyles()}
      ${SpacingStylesProcessor.createSpacingStyles()}
      ${CardStylesProcessor.createCardStyles()}
      ${StepIndicatorStylesProcessor.createStepIndicatorStyles()}
      ${ResetStylesProcessor.createResetStyles()}
    `;
  }
}
